import { useEffect, useState } from "react";
import ProviderDetailsComponent from "../../components/providerComponents/providerDetails/ProviderDetailsComponent";
import { useProviderContext } from "../../components/providerComponents/context/providerContext";
import ManageProviderUsersComponent from "../../components/providerComponents/manageProviderUsers/ManageProviderUsersComponent";

export default function ProviderView() {
  const [loaded, setLoaded] = useState(false);

  const { setHeaderText } = useProviderContext();
  useEffect(() => {
    setHeaderText({
      value: "KIS Provider Details",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);
  const { providerBase, rehydrate } = useProviderContext();
  useEffect(() => {
    rehydrate().then(() => {
      setLoaded(true);
    });
  }, []);

  return (
    <div className="w-full">
      {loaded && (
        <div className="flex flex-column align-items-start w-full height-calc">
          <ProviderDetailsComponent disabled={true} data={providerBase.providerDetails} />
          <ManageProviderUsersComponent />
        </div>
      )}
    </div>
  );
}
